import * as PIXI from 'pixi.js';
import { TimeInvariantBase } from './TimeInvariantBase';
import { getAttributesToSerialize, NumberAttribute } from './attributes';

/**
 * Specifies the position for the Transformation of an Asset
 */
class Position extends TimeInvariantBase {
    override _classType = 'Position';
    @NumberAttribute()
    public x = 0;
    @NumberAttribute()
    public y = 0;

    // eslint-disable-next-line no-useless-constructor
    constructor(settings) {
        super(settings);
    }

    override get readonlyProperties() {
        return [];
    }

    override get propertiesToSerialize() {
        return getAttributesToSerialize(this);
    };
}

/**
 * Specifies the anchor for the Transformation of an Asset.
 */
class Anchor extends TimeInvariantBase {
    override _classType = 'Anchor';
    @NumberAttribute()
    public x = 0;
    @NumberAttribute()
    public y = 0;

    // eslint-disable-next-line no-useless-constructor
    constructor(settings) {
        super(settings);
    }

    override get readonlyProperties() {
        return [];
    }

    override get propertiesToSerialize() {
        return getAttributesToSerialize(this);
    };
}

/**
 * Specifies the Transformation for an Asset which is composed out of a position, rotation and anchor.
 */
export class Transformation extends TimeInvariantBase {
    override _classType = 'Transformation';
    @NumberAttribute()
    public rotation = 0;
    public position = new Position({ parent: this, updateParentOnUpdate: true });
    public anchor = new Anchor({ parent: this, updateParentOnUpdate: true });

    // eslint-disable-next-line no-useless-constructor
    constructor(settings) {
        super(settings);
    }

    override get readonlyProperties() {
        return [];
    }

    override get propertiesToSerialize() {
        return ['position', 'anchor'].concat(getAttributesToSerialize(this));
    };

    get angle() {
        return this.rotation * PIXI.RAD_TO_DEG;
    }

    /**
     * Specifies the rotation in degrees instead of radians
     * @param value
     */
    set angle(value) {
        this.rotation = value * PIXI.DEG_TO_RAD;
    }
}
